import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["noBorder"]
const _hoisted_2 = {
  key: 0,
  class: "p-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Token Prices", -1)
const _hoisted_4 = { class: "p-2 px-4 flex-wrap justify-center gap-[12px]" }

import { computed } from 'vue';

import usePoolCreation from '@/composables/pools/usePoolCreation';
import useBreakpoints from '@/composables/useBreakpoints';
import useNumbers, { FNumFormats } from '@/composables/useNumbers';
import useTokens from '@/composables/useTokens';
import Graph from '@/components/cards/PairPriceGraph/Graph.vue';

type Props = {
  toggleUnknownPriceModal?: () => void;
};


export default _defineComponent({
  props: {
    toggleUnknownPriceModal: { type: Function, required: false }
  } as unknown as undefined,
  setup(__props: {
  toggleUnknownPriceModal?: () => void;
}) {



/**
 * COMPOSABLES
 */
const { upToLargeBreakpoint } = useBreakpoints();
const { tokensList } = usePoolCreation();
const { getToken, priceFor, injectedPrices } = useTokens();
const { fNum2 } = useNumbers();

/**
 * COMPUTED
 */
const validTokens = computed(() => tokensList.value.filter(t => t !== ''));
const knownTokens = computed(() =>
  validTokens.value.filter(
    token => priceFor(token) !== 0 && !injectedPrices.value[token]?.usd
  )
);
const unknownTokens = computed(() =>
  validTokens.value.filter(
    token => priceFor(token) === 0 || injectedPrices.value[token]?.usd
  )
);
const hasUnknownPrice = computed(() =>
  validTokens.value.some(token => priceFor(token) === 0)
);

const USDT = '0x4988a896b1227218e4a686fde5eabdcabd91571f';

return (_ctx: any,_cache: any) => {
  const _component_BalStack = _resolveComponent("BalStack")!

  return (_openBlock(), _createElementBlock("div", {
    noPad: "",
    shadow: "none",
    noBorder: _unref(upToLargeBreakpoint),
    class: "relative"
  }, [
    (!_unref(upToLargeBreakpoint))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_BalStack, {
            horizontal: "",
            spacing: "sm",
            align: "center"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tokensList), (token, idx) => {
        return (_openBlock(), _createBlock(Graph, {
          tokenInAddress: USDT,
          tokenOutAddress: token,
          key: idx
        }, null, 8, ["tokenOutAddress"]))
      }), 128))
    ])
  ], 8, _hoisted_1))
}
}

})